<template>
    <div class="page-temp">
      <div class="left">
        <map-loader
            class="the-map"
            src="maps/royaumes-textes.svg"
            :points="[]"
        ></map-loader>
        <div class="texture">
          <table>
            <tr v-for="(line) in 20" :key="line">
              <td v-for="(col) in 20" :key="col"></td>
            </tr>
          </table>
        </div>
      </div>
      <div class="right">
        <div class="text" v-html="texte"></div>
      </div>

    </div>
</template>

<script>
    import MapLoader from "../components/map/MapLoader";
    // eslint-disable-next-line
    import raw from "raw-loader!../../public/temp-text.html"
    export default {
        name: "PageTemp",
        components: {MapLoader},
        data:function(){
          return{
            "texte":raw
          }
        }
    }

</script>

<style lang="less">
    .page-temp{


        >.left,>.right{
          position: absolute;
          top: 0;
          width: 60%;
          height: 100%;
          //outline: 1px dotted red;
        }
      >.left{
        left: 0;
      }
      >.right{
        width: 40%;
        right: 0;
      }



      >.left{
        background-color: #231B1B;
        background-image: url("../assets/textures/bg-texture.jpg");
        display: flex;
        justify-content: center;
        align-items: center;
        .the-map{
          width: 100%;
          height: 100%;
        }
        >ul{
          position: absolute;
          left: 3vw;
        }
        .texture{
          mix-blend-mode: overlay;
          background-image: url("../assets/textures/texture-transparente.png");
          pointer-events: none;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          table{
            position: absolute;
            width: calc(20*5vw);
            height: calc(20*5vw);
            opacity: 0.3;
            border-collapse: collapse;
            td{
              border: 0.5px solid #fff;
              width: 5vw;
              height: 5vw;
            }

          }
        }
      }
      >.right{
        background-color: #AF2235;
        background-image: url("../assets/textures/bg-texture-rouge.jpg");
        overflow-y: auto;
        .text{
          padding: 5vw;
          p{
            font-weight: 300 !important;
            font-size: 0.95vw;
            line-height: 1.7;
            b,strong{
              font-weight: 600;
            }
          }

          h1{
            font-size: 1.15vw;
          }

        }
      }


    }

</style>